<p-divider align="left"><strong>Modifica Ruoli</strong></p-divider>
<div class="flex flex-column gap-4 mt-3">

	@for (tenantEntry of visibleTenantRoles(); track tenantEntry.tenantId) {
		<div class="border-1 surface-border border-round p-3">

			<!-- Tenant row -->
			<div class="flex align-items-center justify-content-between mb-2">
				<span class="font-bold text-sm">{{ tenantEntry.tenantName }}</span>
				<p-select [options]="tenantRoleOptions"
						  optionLabel="label"
						  optionValue="value"
						  appendTo="body"
						  [ngModel]="tenantEntry.role"
						  (ngModelChange)="onTenantRoleChange(tenantEntry.tenantId, $event)"
				/>
			</div>

			<!-- Mailbox rows -->
			@if (tenantEntry.mailboxRoles.length > 0) {
				<div class="flex flex-column gap-2 pl-3 border-left-2 surface-border">
					@for (mb of tenantEntry.mailboxRoles; track mb.mailboxId) {
						<div class="flex align-items-center justify-content-between py-1">
							<div class="flex align-items-center gap-2">
								<span class="text-sm text-color-secondary">{{ mb.mailboxName }}</span>
								@if (!mb.role) {
									<p-tag value="Nessun ruolo" severity="warn" />
								}
							</div>
							<p-select [options]="mailboxRoleOptions"
									  optionLabel="label"
									  optionValue="value"
									  appendTo="body"
									  size="small"
									  [placeholder]="!mb.role ? 'Assegna ruolo...' : undefined"
									  [ngModel]="mb.role"
									  (ngModelChange)="onMailboxRoleChange(mb.mailboxId, mb.mailboxName, tenantEntry.tenantId, $event)"
							/>
						</div>
					}
				</div>
			} @else {
				<span class="text-sm text-color-secondary pl-3">Nessuna mailbox disponibile</span>
			}

		</div>
	}
</div>
